/*
  - - - - - - - - - - - - - - - - - - - - - - -
  Support Pageable actions for the store.
  Wraps HTTP module and supports setting the result and firing notifications
  - - - - - - - - - - - - - - - - - - - - - - -
*/
import HTTP from '@/utils/http';

export default function pageable() {
  return {
    state: {
      results: new Array(50).fill({}), // We need to pre-populate pageable results arrays so that we can do skeleton loading properly, otherwise it jumps
      totalCount: 0,
      totalPages: 0,
      currentPage: 1,
      offset: 0,
      pagingLimit: 50,
      searchQuery: undefined,
      searchUser: undefined,
      hasLoaded: false,
      meta: {},
    },
    mutations: {
      SET_PAGE_RESULTS(state, { results, count, meta }) {
        state.totalCount = parseInt(count, 10);
        state.totalPages = Math.ceil((state.totalCount / state.pagingLimit));
        state.meta = meta;

        state.results = results;
      },
      SET_PAGE_LIMIT(state, { pageLimit }) {
        state.pagingLimit = parseInt(pageLimit, 10);
      },
      SET_PAGE(state, { page }) {
        state.currentPage = parseInt(page, 10);
        state.offset = (state.currentPage - 1) * state.pagingLimit;
      },
      SET_SEARCH_QUERY(state, { searchQuery }) {
        state.searchQuery = searchQuery;
      },
      CLEAR_SEARCH_QUERY(state) {
        state.searchQuery = undefined;
      },
      SET_SEARCH_USER(state, { searchUser }) {
        state.searchUser = searchUser;
      },
      CLEAR_SEARCH_USER(state) {
        state.searchUser = undefined;
      },
      SET_LOADED(state, loading) {
        state.hasLoaded = loading;
      },
      CLEAR_RESULTS(state) {
        state.results = new Array(state.pagingLimit).fill({});
        state.hasLoaded = false;
      },
    },
    getters: {
      allResults: state => state.results, // TODO Redundant. Should be removed
      pagedResults: state => state.results,
      hasLoaded: state => state.hasLoaded,
      totalPages: state => state.totalPages,
      currentPage: state => state.currentPage - 1,
      totalCount: state => state.meta.total,
      meta: state => state.meta,
    },
    actions: {
      paginatePartialApplication({
        params, // Parameters to send to the server
        transform = data => data, // Custom results transform function. Runs before setters
        ...otherParams // Custom params for HTTP module
      }) {
        return async ({ commit, state }, {
          page, pageLimit, searchQuery, searchUser,
        }) => {
          // if (searchQuery) {
          //   console.log('sq');
          //   console.log(searchQuery);
          //   console.log(params);
          //   const params = { ...params, ...searchQuery }; // eslint-disable-line no-param-reassign
          //   console.log(params);
          //   // commit('SET_SEARCH_QUERY', { searchQuery });
          // } else if (searchQuery === '') {
          //   commit('CLEAR_SEARCH_QUERY');
          // }

          // console.log('params');
          // console.log(params);

          if (searchUser) {
            commit('SET_SEARCH_USER', { searchUser });
          } else if (searchUser === '') {
            commit('CLEAR_SEARCH_USER');
          }

          if (pageLimit) {
            commit('SET_PAGE_LIMIT', { pageLimit });
          }

          if (page) {
            commit('SET_PAGE', { page });
          }

          commit('CLEAR_RESULTS');
          commit('SET_LOADED', false);

          const response = transform(await HTTP({
            ...otherParams,
            params: {
              ...{ ...params, ...searchQuery },
              offset: state.offset,
              limit: state.pagingLimit,
              searchUser: state.searchUser,
            },
          }));

          commit('SET_LOADED', true);
          commit('SET_PAGE_RESULTS', {
            results: response.data.data,
            count: response.data.count,
            meta: response.data.meta,
          });

          return response.data.data;
        };
      },
    },
  };
}
